import {
    Smartphone,
    Code2,
    Network,
    Cctv,
    SatelliteDish,
    LifeBuoy,
} from "lucide-react";

export const COMPANY = {
    name: "Lynxtech IT Solutions",
    brandTop: "LYNX",
    brandBottom: "TECHNOLOGIES",
    address: "Zone Estacion, Agdangan (Pob.), Baao, Camarines Sur, Philippines",
    locality: "Baao, Camarines Sur, Philippines",
    phoneDisplay: "+63 919 831 3310",
    phoneHref: "tel:+639198313310",
    email: "lynxtechitsolutions@gmail.com",
    emailHref: "mailto:lynxtechitsolutions@gmail.com",
    website: "https://www.lynxtech.solutions",
    websiteDisplay: "www.lynxtech.solutions",
    facebook: "https://www.facebook.com/lynxtechitsolutions",
};

export const NAV_LINKS = [
    { label: "Home", testid: "nav-link-home", kind: "home", id: "top" },
    {
        label: "Company Profile",
        testid: "nav-link-company-profile",
        kind: "route",
        path: "/company-profile",
    },
    { label: "About", testid: "nav-link-about", kind: "home", id: "about" },
    { label: "Services", testid: "nav-link-services", kind: "home", id: "services" },
    { label: "Why Choose Us", testid: "nav-link-why", kind: "home", id: "why" },
    { label: "Contact", testid: "nav-link-contact", kind: "home", id: "contact" },
];

export const SERVICES = [
    {
        key: "mobile",
        icon: Smartphone,
        title: "Mobile Platform Provider",
        blurb:
            "Mobile application development and digital platform solutions designed around real business workflows.",
        points: [
            "Mobile application development",
            "Business-focused digital applications",
            "Platform design and implementation",
            "Custom digital experiences",
        ],
        testid: "service-card-mobile",
    },
    {
        key: "software",
        icon: Code2,
        title: "Software & Solutions Provider",
        blurb:
            "Custom software and web-based systems that digitalize and streamline day-to-day operations.",
        points: [
            "Custom software solutions",
            "Business process digitalization",
            "Web-based applications & system integration",
            "Software maintenance and support",
        ],
        testid: "service-card-software",
    },
    {
        key: "hardware",
        icon: Network,
        title: "Hardware & Network Systems",
        blurb:
            "Computer hardware, LAN setup, and network infrastructure for dependable business connectivity.",
        points: [
            "Computer hardware solutions",
            "Local area network (LAN) installation",
            "Network equipment configuration",
            "Hardware deployment, maintenance & troubleshooting",
        ],
        testid: "service-card-hardware",
    },
    {
        key: "cctv",
        icon: Cctv,
        title: "CCTV Installation & Security Systems",
        blurb:
            "Planning and installation of network-connected camera systems for homes, offices, and facilities.",
        points: [
            "CCTV system installation & camera setup",
            "Camera placement planning",
            "Network-connected camera systems",
            "System maintenance and troubleshooting",
        ],
        testid: "service-card-cctv",
    },
    {
        key: "starlink",
        icon: SatelliteDish,
        title: "Starlink Installation & Connectivity",
        blurb:
            "Installation assistance and connectivity setup for Starlink equipment, tailored to each site.",
        points: [
            "Starlink equipment installation assistance",
            "Dish placement and setup assistance",
            "Connectivity setup & network integration",
            "Configuration and troubleshooting",
        ],
        testid: "service-card-starlink",
    },
    {
        key: "support",
        icon: LifeBuoy,
        title: "Technical Support & Systems Assistance",
        blurb:
            "Deployment guidance, troubleshooting, and follow-up assistance as your requirements evolve.",
        points: [
            "Deployment and configuration guidance",
            "Technical troubleshooting",
            "Systems maintenance",
            "Responsive follow-up assistance",
        ],
        testid: "service-card-support",
    },
];

export const SERVICE_OPTIONS = [
    { value: "mobile", label: "Mobile Platform Development" },
    { value: "software", label: "Software & Solutions" },
    { value: "hardware", label: "Hardware & Network Systems" },
    { value: "cctv", label: "CCTV Installation" },
    { value: "starlink", label: "Starlink Installation" },
    { value: "support", label: "Technical Support" },
    { value: "other", label: "Other Inquiry" },
];
